import styles from './StoresBlock.module.css';
import apple from './images/astore.svg';
import playstore from './images/gstore.svg';
import downloadOnThe from './images/getiton.svg';
import appStore from './images/appstoretext.svg';
import getiton from './images/getiton.svg';
import gplaytext from './images/googleplaytext.svg';

export const StoresBlock = () => {
	return (
		<div className={styles.container}>
			<p className={styles.text}>Or get extended trial in app:</p>
			<div className={styles.btns}>
				<a
					href="https://botify.go.link/?adj_t=12s6itdd&adj_campaign=paywall_link"
					className={styles.btn}
				>
					<div className={styles.left}>
						<img className={styles.apple} alt="Apple" src={apple} />
					</div>
					<div className={styles.right}>
						<img
							className={styles['download-on-the']}
							alt="Download on the"
							src={downloadOnThe}
						/>
						<img
							className={styles['app-store']}
							alt="App store"
							src={appStore}
						/>
					</div>
				</a>
				<a
					href="https://botify.go.link/?adj_t=12ut5c2z&adj_deep_link=botify%3A%2F%2F&adj_campaign=paywall_link"
					className={styles.btn}
				>
					<div className={styles.left}>
						<img className={styles.playstore} alt="Playstore" src={playstore} />
					</div>
					<div className={styles.right}>
						<img
							className={styles['GET-IT-ON']}
							alt="Get IT ON"
							src={getiton}
						/>
						<img className={styles.path} alt="Path" src={gplaytext} />
					</div>
				</a>
			</div>
		</div>
	);
};
